module.exports = __webpack_public_path__ + "static/media/stump-933702_640.d6c805d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stump-933702_640.jpg
// module id = 41
// module chunks = 0